import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Flame, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await register(form);
      toast.success("Account created! Let's trade.");
      nav(user.role === "admin" ? "/travisb-admin" : "/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tb-glow min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <span className="w-10 h-10 rounded-xl flex items-center justify-center tb-btn-primary"><span className="font-head font-extrabold text-white text-lg">T</span></span>
          <span className="font-head font-extrabold text-xl text-white">Travis<span className="tb-gradient-text">B</span></span>
        </Link>
        <div className="tb-card p-7 sm:p-8">
          <h1 className="font-head text-2xl font-bold text-white mb-1">Create your account</h1>
          <p className="text-sm text-gray-400 mb-6">Join thousands trading on Nigeria's fastest exchange.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-gray-400">Full name</label>
              <input data-testid="signup-name-input" required value={form.name} onChange={set("name")} className="mt-1.5 w-full px-4 py-3 rounded-xl bg-[#0A1026] border border-blue-500/25 text-white outline-none focus:border-blue-400" placeholder="John Doe" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-gray-400">Email</label>
              <input data-testid="signup-email-input" type="email" required value={form.email} onChange={set("email")} className="mt-1.5 w-full px-4 py-3 rounded-xl bg-[#0A1026] border border-blue-500/25 text-white outline-none focus:border-blue-400" placeholder="you@example.com" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-gray-400">Phone (WhatsApp)</label>
              <input data-testid="signup-phone-input" value={form.phone} onChange={set("phone")} className="mt-1.5 w-full px-4 py-3 rounded-xl bg-[#0A1026] border border-blue-500/25 text-white outline-none focus:border-blue-400" placeholder="2348012345678" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-gray-400">Password</label>
              <input data-testid="signup-password-input" type="password" required value={form.password} onChange={set("password")} className="mt-1.5 w-full px-4 py-3 rounded-xl bg-[#0A1026] border border-blue-500/25 text-white outline-none focus:border-blue-400" placeholder="Choose a strong password" />
            </div>
            <button data-testid="signup-submit-button" disabled={loading} className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-semibold tb-btn-primary disabled:opacity-60">
              {loading && <Loader2 size={18} className="animate-spin" />} Create Account
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-gray-400">
            Already have an account? <Link to="/login" data-testid="signup-to-login-link" className="text-blue-300 font-semibold hover:text-blue-200">Log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
